import React from 'react';
import QuickServices from '../../QuickServices/QuickServices';
import RecentBooking from '../../RecentBooking/RecentBooking';

import { connect } from 'react-redux';

const userHome = (props) => {

    let recentBooking = false;

    let recentTrips = null;
    let upcomingTrips = null;
    let pastTrips = null;
    if (props.recentBooking !== null) {
        let recentBookingData = props.recentBooking.data.recentBookings.flight;
        if (recentBookingData.re.length === 0 &&  recentBookingData.up.length === 0 && recentBookingData.ps.length === 0) {
            recentBooking = false;
        } else {
            recentTrips = recentBookingData.re;
            upcomingTrips = recentBookingData.up;
            pastTrips = recentBookingData.ps;
            recentBooking = true;
        }
    }

    return (
        <React.Fragment>
            <div className={`mb-10`}>
                <div className={`mb-4`}>
                    <h3 className={`u-fontSize16 u-fontWeightMedium u-textColorDark`}>Quick Services</h3>
                </div>
                <QuickServices/>
            </div>
            {
                recentBooking ? <div className={`mb-10`}>
                    <div className={`mb-4`}>
                        <h3 className={`u-fontSize16 u-fontWeightMedium u-textColorDark`}>Recent Bookings</h3>
                    </div>
                    <RecentBooking rt={recentTrips} ut={upcomingTrips} pt={pastTrips} />
            </div> : null
            }
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        recentBooking: state.auth.flightRecentBooking
    }
}

export default connect(mapStateToProps)(userHome);


// WEBPACK FOOTER //
// ./src/components/User/UserHome/UserHome.js